import { useEffect, useState } from 'react';
import listenForResize from './listenForResize';
export default function useElementHeight(ref) {
    const [height, setHeight] = useState(0);
    // record the initial height after the first render of the target element
    useEffect(() => {
        var _a;
        setHeight((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height);
    }, [ref]);
    const currentElement = ref === null || ref === void 0 ? void 0 : ref.current;
    // watch the height of the target element and record every time
    // it changes
    useEffect(() => {
        if (!currentElement)
            return undefined;
        const removeListener = listenForResize(currentElement, (resizeEvent) => setHeight(resizeEvent.contentRect.height));
        return removeListener;
    }, [currentElement]);
    return height;
}
//# sourceMappingURL=useElementHeight.js.map